module.exports = "<h1>PRODUCT</h1>\r\n<button mat-raised-button color=\"primary\" (click)=\"agregarProductoVenta01()\">\r\n    aaaaa\r\n    </button>"